<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="1M"
            label="변경 작업 기간"
            name="mocPeriod"
            v-model="searchParam.mocPeriod"
          />
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 발의부서 -->
          <c-dept type="search" label="LBL0001903" name="initiativeDeptCd" v-model="searchParam.initiativeDeptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            :comboItems="stepItems"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="mocStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.mocStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 임시변경-MOC 목록 -->
    <c-table
      ref="table"
      title="LBL0002038"
      tableId="moctemp01"
      :columns="grid.columns"
      :data="grid.data"
      :merge="grid.merge"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn v-if="editable" label="LBLREG" icon="add_circle" @btnClicked="openPopup" />
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <div v-if="props.row[col.name]"
          :class="[
            props.row[col.name] === 'O' || props.row[col.name] === 'Y' ? 'text-green' : 'text-red-7', 
            'text-bold'
          ]">
          {{ props.row[col.name] === 'Y' ? 'O' : props.row[col.name] === 'N' ? 'X' : props.row[col.name] }}
        </div>
        <template v-else></template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'moc-temp',
  data() {
    return {
      searchParam: {
        plantCd: null,
        mocPeriod: [],
        initiativeDeptCd: null,
        mocStepCd: null,
        mocTypeCd: 'MT00000005',
      },
      grid: {
        merge: [
          { index: 0, colName: 'initiativeYear' },
        ],
        columns: [
          {
            name: 'initiativeYear',
            field: 'initiativeYear',
            label: 'LBLYEAR',
            align: 'center',
            style: 'width:60px',
            sortable: true
          },
          {
            name: 'yearRank',
            field: 'yearRank',
            label: '#',
            align: 'center',
            style: 'width:45px',
            sortable: true
          },
          {
            name: 'initiativeDt',
            field: 'initiativeDt',
            // 발의일
            label: 'LBL0001905',
            align: 'center',
            style: 'width:80px',
            sortable: true
          },
          {
            name: 'mocTitle',
            field: 'mocTitle',
            // 제목
            label: 'LBLTITLE',
            align: 'left',
            sortable: true,
            style: 'width:280px',
            type: 'link',
          },
          {
            name: 'mocStepName',
            field: 'mocStepName',
            // 진행단계
            label: 'LBLSTEPPROGRESS',
            align: 'center',
            style: 'width:90px',
            sortable: true
          },
          // {
          //   name: 'bizApprStepNm',
          //   field: 'bizApprStepNm',
          //   label: '결재진행단계',
          //   align: 'center',
          //   style: 'width:100px',
          //   sortable: true
          // },
          {
            name: 'mocTypeName',
            field: 'mocTypeName',
            // 변경구분
            label: 'LBL0001906',
            align: 'center',
            style: 'width:70px',
            sortable: true
          },
          {
            name: 'changeFlag',
            field: 'changeFlag',
            // 변경관리<br/>위원회<br/>승인여부<br/>(o,x)
            label: 'LBL0001907',
            align: 'center',
            style: 'width:80px',
            sortable: true,
            type: 'custom',
          },
          {
            name: 'psi',
            field: 'psi',
            // 공정안전자료
            label: 'LBL0001908',
            child: [
              {
                name: 'pidFlag',
                field: 'pidFlag',
                // P&ID<br/>(o,x)
                label: 'LBL0001909',
                align: 'center',
                style: 'width:70px',
                sortable: true,
                type: 'custom',
              },
              {
                name: 'powerMachineFlag',
                field: 'powerMachineFlag',
                // 동력기계<br/>(o,x)
                label: 'LBL0001910',
                align: 'center',
                style: 'width:70px',
                sortable: true,
                type: 'custom',
              },
              {
                name: 'deviceEquipmentFlag',
                field: 'deviceEquipmentFlag',
                // 장치 및 설비<br/>(o,x)
                label: 'LBL0001911',
                align: 'center',
                style: 'width:90px',
                sortable: true,
                type: 'custom',
              },
              {
                name: 'pipeGasketFlag',
                field: 'pipeGasketFlag',
                // 배관 및<br/>개스킷<br/>(o,x)
                label: 'LBL0001912',
                align: 'center',
                style: 'width:70px',
                sortable: true,
                type: 'custom',
              },
              {
                name: 'safetyValveRuptureDiskFlag',
                field: 'safetyValveRuptureDiskFlag',
                // 안전밸브 및<br/>파열판<br/>(o,x)
                label: 'LBL0001913',
                align: 'center',
                style: 'width:80px',
                sortable: true,
                type: 'custom',
              },
              {
                name: 'documentFlag',
                field: 'documentFlag',
                // 절차서<br/>(o,x)
                label: 'LBL0001914',
                align: 'center',
                style: 'width:70px',
                sortable: true,
                type: 'custom',
              },
            ]
          },
          {
            name: 'riskAssessFlag',
            field: 'riskAssessFlag',
            // 위험성평가<br/>(o,x)
            label: 'LBL0001915',
            align: 'center',
            style: 'width:80px',
            sortable: true,
            type: 'custom',
          },
          {
            name: 'preStartFlag',
            field: 'preStartFlag',
            // 가동전점검<br/>(o,x)
            label: 'LBL0001916',
            align: 'center',
            style: 'width:80px',
            sortable: true,
            type: 'custom',
          },
          {
            name: 'eduFlag',
            field: 'eduFlag',
            // 교육<br/>(o,x)
            label: 'LBL0001917',
            align: 'center',
            style: 'width:60px',
            sortable: true,
            type: 'custom',
          },
          {
            name: 'mocNo',
            field: 'mocNo',
            // 관리번호
            label: 'LBL0001918',
            align: 'center',
            style: 'width:110px',
            sortable: true
          },
          {
            name: 'mocDates',
            field: 'mocDates',
            // 변경 작업 기간
            label: 'LBL0001919',
            align: 'center',
            style: 'width:170px',
            sortable: true
          },
          {
            name: 'initiativeUserName',
            field: 'initiativeUserName',
            // 발의자
            label: 'LBL0001920',
            align: 'center',
            style: 'width:80px',
            sortable: true
          },
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:90px',
            sortable: true,
          },
        ],
        data: [],
      },
      stepItems: [],
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.moc.change.list.url
      // code setting
      this.$comm.getStepItems('MOC_TEMP_STEP_CD').then(_result => {
        let idx = this.$_.findIndex(_result, { stepperMstCd: 'MT00000020' });
        this.$set(_result[idx], 'stepperMstNm', _result[idx - 1].stepperMstNm + ' / ' + _result[idx].stepperMstNm)
        _result = this.$_.reject(_result, { stepperMstCd: 'MT00000015' })
        this.stepItems = _result;
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      if (!row) return;
      this.openPopup(row)
    },
    openPopup(row) {
      this.popupOptions.title = 'LBL0001921'; // 변경관리 상세
      this.popupOptions.param = {
        sopMocId: row ? row.sopMocId : '',
        mocTypeCd: row ? row.mocTypeCd : 'MT00000005',
        mocStepCd: row ? row.mocStepCd : '',
      };
      this.popupOptions.target = () => import(`${'./mocDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
